import {Typography} from "@mui/material";

export const DpvInfoContent = () => {


    return {
        title: 'Data Point Values',
        content: (
            <>
                <Typography paragraph>
                    Data Point Values are predefined value lists that belong
                    to a specific Data Point.
                </Typography>

                <ul>
                    <li>
                        Each Data Point Value belongs to one and only one
                        Data Point.
                    </li>

                    <li>
                        They provide the selectable options that appear in
                        dropdown menus when assigning Contract Data Point
                        Values to contracts.
                    </li>

                    <li>
                        Data Point Values are typically used when a Data Point
                        has a Data Type of <strong>Code</strong> or
                        <strong> Yes/No</strong>.
                    </li>

                    <li>
                        Examples include contract levels, guilds, payment
                        statuses, and other controlled lists
                        of values.
                    </li>

                    <li>
                        A Data Point must have a Data Type of Code or Yes/No
                        before Data Point Values can be assigned to it.
                    </li>

                    <li>
                        Data Types such as Number, Percentage, Free Text,
                        and Date have values that are entered directly
                        when creating a Contract Data Point Value rather than
                        being selected from a predefined list.
                    </li>
                </ul>
            </>
        )
    };

};